import {
  configureStore,
  ThunkAction,
  Action,
  combineReducers,
} from '@reduxjs/toolkit';
import pageReducer from './slices/pageSlice';
import locationReducer from './slices/locationSlice';
import metadataSlice from './slices/metadataSlice';
import userSlice from './slices/userSlice';

const rootReducer = combineReducers({
  pages: pageReducer,
  location: locationReducer,
  metadata: metadataSlice,
  user: userSlice,
});

export const store = configureStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      immutableCheck: false,
      serializableCheck: false,
    }),
  devTools: process.env.NODE_ENV === 'development',
});

export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;
export type AppThunk<ReturnType = void> = ThunkAction<
  ReturnType,
  RootState,
  unknown,
  Action<string>
>;
